import React, { useEffect, useState } from "react";
import "./SuccessBlock.css";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import successCloudImage from "../assets/img/tick-cloud.png";
import Footer from "./Footer";

const SuccessBlock = (props) => {
    const location = useLocation(); // To receive cgurl from homepage
    const [selectedPack, setSelectedPack] = useState("");
    const [selectedPackPrice, setSelectedPackPrice] = useState("");

    useEffect(() => {
        // Retrieve selected pack value from localStorage
        const packValue = localStorage.getItem("selectedPack");
        const packPrice = localStorage.getItem("selectedPackPrice");

        if (packValue) {
            setSelectedPack(packValue);
        }
        if (packPrice) {
            setSelectedPackPrice(packPrice);
        }
    }, []);

    let redirectUrl =
        "https://www.etisalat.ae/en/c/digital-lifestyle/add-to-bill.html";

    const handleRedirect = () => {
        window.location.replace(redirectUrl);
    };

    return (
        <div>
            <Header />
            <div className="success-container">
                {/* Order successful message */}
                <div className="order-successful-message">
                    <img className="pulse" src={successCloudImage} alt="Success" />
                    <h1>Order successful</h1>
                    <p>Thank you for your purchase.</p>
                    <p className="Number">{selectedPackPrice}</p>
                    <p className="Vat">5% Vat incl.</p>{" "}
                    {/* Display selected pack value */}
                </div>

                <div className="success-description">
                    <button className="success-btn" onClick={handleRedirect}>
                        Done
                    </button>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SuccessBlock;
